/** Extracts the quoted filename format emitted by download endpoints as Content-Disposition headers. */
export function getFileNameFromContentDisposition(contentDisposition: string | null): string | null {
  const fileName = contentDisposition?.match(/filename="([^"]+)"/i)?.[1]?.trim()
  return fileName || null
}
